import { Injectable } from '@angular/core';
import { CUserService } from '../../../../services/ServiceEntity/c-user.service';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { ICUser } from '../../../../model/c-user.model';
import { ICuserListService } from './i-cuser-list.service';

/**
 * Liste tous les utilisateurs de la base de données
 * créé par l'utilisateur connecté.
 */
@Injectable({ providedIn: 'root' })
export class PartenerUserListService implements ICuserListService{


  constructor(private cUserService: CUserService) {
  }

  /**
   * @return Liste tous les utilisateurs de la base de données
   * créé par l'utilisateur connecté.
   */
  loadAll(): Observable<HttpResponse<ICUser[]>> {
    return this.cUserService.queryListWithStatus();
  }

  getUser(req?): Observable<HttpResponse<ICUser>> {
    return this.cUserService.getUserWithStatusByUserConnected(req);
  }

}